export default __webpack_public_path__ + "static/media/cloud.883023be.svg";